export * from './lib/core-data.module';
export { DataService as CoreDataService, TypeKey } from './lib/data.service';
export { PersistenceService } from './lib/persistence.service'
export * from './lib/helpers';